import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Navbar } from "flowbite-react";
import NavbarLogo from "./NavbarLogo";
import NavbarCollapse from "./NavbarCollapse";

function NavbarRefractedV4new2() {
  const [darkMode, setDarkMode] = useState(true);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("dark");
    }
  }, [darkMode]);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div className="relative z-50 w-full">
      {/* Background div */}
      <div className="fixed top-0 w-full px-4 bg-opacity-50 sm:px-12 sm:m-24 left-1/2 dark:bg-opacity-50 backdrop-blur-md"></div>
      {/* Content div */}
      <Navbar
        fluid
        rounded
        className="fixed top-0 z-50 w-full mt-4 bg-opacity-50 border bg-guinera-500 dark:bg-guinera-900 dark:bg-opacity-50 backdrop-blur-md rounded-2xl border-guinera-400 dark:border-guinera-600 dark:border-opacity-20"
      >
        <div className="flex items-center justify-between w-full p-4 m-4">
          <Navbar.Brand as={Link} to="/">
            <NavbarLogo darkMode={darkMode} />
          </Navbar.Brand>
          <Navbar.Toggle onClick={toggleMobileMenu} />
          <NavbarCollapse
            isMobileMenuOpen={isMobileMenuOpen}
            toggleDarkMode={toggleDarkMode}
            darkMode={darkMode}
          />
        </div>
      </Navbar>
    </div>
  );
}

export default NavbarRefractedV4new2;
